module.exports = __webpack_public_path__ + "img/3-Enter-key.a39970a1.png";